import { ConcreteEncodable } from "./ConcreteEncodable";

import { OpsFilterCompositeDataImplEncoder } from "../../encoder/OpsFilterCompositeDataImplEncoder";

import * as CubiqTS from "../../index";
import { OpsFilterCompositeData } from "../OpsFilterCompositeData";

export class OpsFilterCompositeDataImpl
  extends ConcreteEncodable
  implements OpsFilterCompositeData
{
  public static enType: string = "com.bcdfx.model.opsfilters.OpsFilterCompositeDataImpl";

  /*FID=1*/
  public opsFilterCategories: Array<CubiqTS.OpsFiltCategory> | null = null;
  /*FID=2*/
  public opsFilterCategoryTypes: Array<CubiqTS.OpsFiltCategoryType> | null = null;
  /*FID=100*/
  public messageId: string;
  public sessionOnly: string;

  constructor() {
    super();
    this.encoder = OpsFilterCompositeDataImplEncoder.Instance;
    this.setEncodableType(OpsFilterCompositeDataImpl.enType);
    //Model
  }

  public toString(): string {
    return (
      "OpsFilterCompositeDataImpl[" +
      "opsFilterCategories=" +
      this.opsFilterCategories +
      "opsFilterCategoryTypes=" +
      this.opsFilterCategoryTypes +
      "messageId=" +
      this.messageId +
      "]"
    );
  }

  public validateInbound(): void {}

  public validateOutbound(): void {}
}
